export default __webpack_public_path__ + "static/media/hht2_ep05_book_wp_02.ccd1c000.jpg";